import React from 'react';
import { Link } from 'react-router-dom';

function TermsPage() {
  return (
    <div className="agento-page">
      <nav className="agento-nav">
        <div className="agento-nav-inner">
          <Link to="/" className="agento-nav-brand">ZitotronTech</Link>
          <div className="agento-nav-links">
            <Link to="/agento">Agento</Link>
          </div>
        </div>
      </nav>

      <div className="legal-page">
        <div className="legal-content">
          <h1>Terms of Service</h1>
          <p className="legal-effective">Effective Date: March 15, 2026</p>

          <p>
            These Terms of Service ("Terms") govern your access to and use of the products,
            services, and websites (collectively, "Services") provided by Zito Tron Tech LLC
            ("Company", "we", "us", or "our"). By accessing or using our Services, you agree
            to be bound by these Terms.
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By creating an account, purchasing a subscription, or using any of our Services,
            you acknowledge that you have read, understood, and agree to be bound by these
            Terms. If you do not agree to these Terms, you may not access or use our Services.
          </p>

          <h2>2. Account Terms</h2>
          <p>
            You are responsible for maintaining the security of your account and license key.
            You are responsible for all activities that occur under your account. You must
            provide accurate and complete information when creating your account. You must
            notify us immediately of any unauthorized use of your account.
          </p>

          <h2>3. Payment and Subscriptions</h2>
          <p>
            Our Services are offered on a subscription basis. By subscribing, you authorize
            us to charge the applicable fees to your payment method on a recurring basis.
          </p>
          <ul>
            <li>Subscriptions automatically renew at the end of each billing period unless cancelled.</li>
            <li>You may cancel your subscription at any time. Cancellation takes effect at the end of the current billing period.</li>
            <li>Prices are subject to change with 30 days' notice.</li>
            <li>All fees are exclusive of taxes unless otherwise stated.</li>
          </ul>

          <h2>4. Refund Policy</h2>
          <p>
            We offer a 14-day refund policy from the date of purchase, no questions asked.
            To request a refund, contact us at support@zitotrontech.com. Refunds are processed
            to the original payment method within 5-10 business days.
          </p>

          <h2>5. License Grant</h2>
          <p>
            Subject to your compliance with these Terms and payment of applicable fees, we
            grant you a limited, non-exclusive, non-transferable, revocable license to use
            our software for the duration of your active subscription. This license is for
            your personal or internal business use only.
          </p>

          <h2>6. Restrictions</h2>
          <p>You may not:</p>
          <ul>
            <li>Reverse engineer, decompile, or disassemble the software.</li>
            <li>Redistribute, sublicense, sell, or lease the software to any third party.</li>
            <li>Remove or alter any proprietary notices, labels, or marks.</li>
            <li>Use the software to develop a competing product or service.</li>
            <li>Exceed the device limits specified in your license agreement.</li>
            <li>Share your license key with unauthorized users.</li>
          </ul>

          <h2>7. Termination</h2>
          <p>
            We may suspend or terminate your access to our Services at any time if you violate
            these Terms. Upon termination, your license to use the software is immediately
            revoked. You may terminate your account at any time by cancelling your subscription
            and contacting us.
          </p>

          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, Zito Tron Tech LLC shall not
            be liable for any indirect, incidental, special, consequential, or punitive damages,
            or any loss of profits or revenues, whether incurred directly or indirectly, or any
            loss of data, use, goodwill, or other intangible losses resulting from your use of
            or inability to use the Services. In no event shall our aggregate liability exceed
            the amount you paid us in the twelve (12) months preceding the claim.
          </p>

          <h2>9. Disclaimer of Warranties</h2>
          <p>
            The Services are provided "as is" and "as available" without warranties of any kind,
            whether express or implied, including but not limited to implied warranties of
            merchantability, fitness for a particular purpose, and non-infringement.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            State of Delaware, United States, without regard to its conflict of law provisions.
            Any disputes arising under or in connection with these Terms shall be subject to the
            exclusive jurisdiction of the courts located in Delaware.
          </p>

          <h2>11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of any
            material changes by posting the updated Terms on our website and updating the
            effective date. Your continued use of the Services after such changes constitutes
            your acceptance of the new Terms.
          </p>

          <h2>12. Contact</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p>
            Zito Tron Tech LLC<br />
            Email: support@zitotrontech.com
          </p>
        </div>
      </div>

      <footer className="agento-footer">
        <div className="container">
          <div className="agento-footer-content">
            <p>&copy; 2026 Zito Tron Tech LLC. All rights reserved.</p>
            <div className="agento-footer-links">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/agento/eula">EULA</Link>
              <a href="mailto:support@zitotrontech.com">support@zitotrontech.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TermsPage;
